import React from 'react';
import { Section } from '../ui/Section';
import { Check, X, Zap } from 'lucide-react';
export function PlugPlayComparison() {
  const features = ['100 publicaciones listas', 'Scripts de venta avanzados', 'Ideas de reels virales', 'Ofertas que venden solas', 'Plan 30 días paso a paso', 'Sistema completo armado'];
  return <Section className="bg-dark-900 border-t border-dark-800" data-id="element-160">
      <div className="text-center mb-16" data-id="element-161">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-6 flex items-center justify-center gap-4" data-id="element-162">
          <Zap className="text-gold-500 w-10 h-10" data-id="element-163" />
          ¿QUÉ AGREGA EL SISTEMA PLUG & PLAY?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-164">
        {/* Situation */}
        <div className="bg-dark-800 rounded-2xl p-6 md:p-8 mb-12 flex flex-col md:flex-row justify-between items-center gap-6 border border-dark-700" data-id="element-165">
          <div className="text-center md:text-left" data-id="element-166">
            <span className="text-gray-400 font-bold uppercase text-sm tracking-wider mb-2 block" data-id="element-167">
              🧠 Situación Real
            </span>
            <p className="text-xl text-gray-300" data-id="element-168">
              <span className="text-red-500" data-id="element-169">❌ Sin sistema</span> → No sabés
              qué hacer
            </p>
          </div>
          <div className="hidden md:block w-px h-12 bg-dark-600" data-id="element-170" />
          <div className="text-center md:text-left" data-id="element-171">
            <p className="text-xl text-white font-bold" data-id="element-172">
              <span className="text-green-500" data-id="element-173">✅ Con sistema</span> → Todo
              listo para ejecutar
            </p>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-174">
          <div className="bg-dark-800/50 border border-red-900/30 p-8 rounded-2xl" data-id="element-175">
            <h3 className="text-xl font-bold text-gray-400 mb-6 text-center" data-id="element-176">
              SIN PLUG & PLAY
            </h3>
            <ul className="space-y-4" data-id="element-177">
              <li className="flex items-center gap-3 text-gray-400" data-id="element-178">
                <X className="text-red-500 w-5 h-5 shrink-0" data-id="element-179" /> Pensás qué
                publicar
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-180">
                <X className="text-red-500 w-5 h-5 shrink-0" data-id="element-181" /> Dudás qué decir
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-182">
                <X className="text-red-500 w-5 h-5 shrink-0" data-id="element-183" /> Perdés ventas
              </li>
            </ul>
          </div>

          <div className="bg-dark-800 border border-gold-500/30 p-8 rounded-2xl relative overflow-hidden" data-id="element-184">
            <div className="absolute inset-0 bg-gold-500/5" data-id="element-185" />
            <h3 className="text-xl font-black text-gold-400 mb-6 text-center relative z-10" data-id="element-186">
              CON PLUG & PLAY
            </h3>
            <ul className="space-y-4 relative z-10" data-id="element-187">
              <li className="flex items-center gap-3 text-white font-medium" data-id="element-188">
                <Check className="text-green-500 w-5 h-5 shrink-0" data-id="element-189" />{' '}
                Publicaciones listas
              </li>
              <li className="flex items-center gap-3 text-white font-medium" data-id="element-190">
                <Check className="text-green-500 w-5 h-5 shrink-0" data-id="element-191" /> Mensajes
                que venden
              </li>
              <li className="flex items-center gap-3 text-white font-medium" data-id="element-192">
                <Check className="text-green-500 w-5 h-5 shrink-0" data-id="element-193" /> Sistema
                armado
              </li>
            </ul>
          </div>
        </div>

        {/* Includes List */}
        <div className="bg-dark-900 border border-dark-700 p-8 md:p-12 rounded-3xl" data-id="element-194">
          <h3 className="text-2xl font-black text-white mb-8 text-center" data-id="element-195">
            ✅ INCLUYE:
          </h3>
          <div className="grid sm:grid-cols-2 gap-6" data-id="element-196">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3 bg-dark-800 p-4 rounded-xl" data-id="element-197">
                <Check className="text-gold-500 w-6 h-6 shrink-0" data-id="element-198" />
                <span className="text-gray-200 font-medium" data-id="element-199">{feature}</span>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}